type TInitialState = {
  title: string;
  message: string;
  isSnackbarOpen: boolean;
  severity?: 'error' | 'success' | 'warning' | 'info';
  /** exact technical error for IT (kept out of the user message) */
  details?: string;
  /** what the user was doing, e.g. "Save sales order" */
  action?: string;
};
const initialState: TInitialState = {
  title: "",
  message: "",
  isSnackbarOpen: false,
  severity: undefined,
};

const snackbarReducer = (state = initialState, action: any = {}) => {
  switch (action.type) {
    case "OPEN_SNACK_TOAST":
      return {
        ...state,
        title: action.payload.title,
        message: action.payload.message,
        severity: action.payload.severity,
        details: action.payload.details,
        action: action.payload.action,
        isSnackbarOpen: true,
      };
    case "CLOSE_SNACK_TOAST":
      return {
        ...state,
        isSnackbarOpen: false,
        severity: undefined,
        details: undefined,
        action: undefined,
      };
    default:
      return state;
  }
};

export default snackbarReducer;

;